import React from 'react';

export default function Section({ id, num, title, subtitle, children }) {
  return (
    <section id={id} className="section" data-section>
      <div className="container">
        <div className="section__header reveal">
          <span className="section__num">{num} —</span>
          <div>
            <h2 className="section__title">{title}</h2>
            <p className="section__subtitle">{subtitle}</p>
          </div>
        </div>
        {children}
      </div>
    </section>
  );
}
